/* Homepage series tiles and devices.
   Same validated source, strict stock rule (available + tracked + quantity > 0) and series names as the
   megamenu and the refurbished collection: PrimeFoneRefurbData (refurbished-menu.js) + the shared
   product card (PrimeFoneCollection.card). Nothing from the mockup, no example prices or models. */
(function () {
  'use strict';
  if (window.pfHomeCatalogInstalled) return;
  window.pfHomeCatalogInstalled = true;
  const el = (tag, className, text) => { const node = document.createElement(tag); if (className) node.className = className; if (text !== undefined) node.textContent = text; return node; };
  function arrow() {
    const ns = 'http://www.w3.org/2000/svg', svg = document.createElementNS(ns, 'svg'), path = document.createElementNS(ns, 'path');
    for (const [name, value] of Object.entries({width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': 2.2, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true'})) svg.setAttribute(name, value);
    path.setAttribute('d', 'M5 12h14m-6-6 6 6-6 6'); svg.append(path); return svg;
  }
  const json = (scope, selector) => { try { return JSON.parse(scope.querySelector(selector)?.textContent || '[]'); } catch (error) { return []; } };
  function photo(img, entry, className) {
    img.src = entry.src; if (entry.srcset) img.srcset = entry.srcset; img.sizes = '(min-width: 1024px) 300px, 50vw';
    img.alt = entry.alt || img.alt; img.classList.add(className);
  }
  function done(root, message) {
    root.querySelectorAll('[data-pf-skeleton]').forEach(node => node.remove());
    root.setAttribute('aria-busy', 'false');
    const status = root.parentElement.querySelector('[data-pf-home-status]');
    if (status && message) { status.textContent = message; status.hidden = false; }
  }

  // Series: only series with strictly saleable devices; label and link exactly as in the megamenu.
  function series(root, data) {
    data.catalog().then(catalog => {
      if (!catalog) { done(root, 'De series konden nu niet worden geladen. Bekijk alle modellen hieronder.'); return; }
      const max = Number(root.dataset.max) || 0, all = root.querySelector('[data-pf-home-series-all]'), photos = json(root.parentElement, '[data-pf-home-series-photos]');
      // Newest first by series number (X = 10, SE last), then the first 'max' (0 = all).
      const rank = name => { const m = name.match(/^iPhone (\d+)/); return m ? Number(m[1]) : name === 'iPhone X' ? 10 : 0; };
      const sorted = catalog.series.slice().sort((a, b) => rank(b.name) - rank(a.name));
      const entries = max > 0 ? sorted.slice(0, max) : sorted;
      entries.forEach(entry => {
        const label = data.seriesLabel(entry.name), tile = el('a', 'pf-hseries__tile');
        tile.href = entry.url;
        const media = el('span', 'pf-hseries__media');
        // A configured series photo wins; otherwise the real product photo of a saleable model.
        const seriesPhoto = photos.find(p => p.series === entry.name && p.src);
        if (seriesPhoto || entry.image) {
          const img = el('img'); img.alt = ''; img.width = 560; img.height = 560; img.loading = 'lazy'; img.decoding = 'async';
          if (seriesPhoto) { img.width = 960; img.height = 640; photo(img, seriesPhoto, 'pf-hseries__img--photo'); } else img.src = entry.image;
          media.append(img);
        } else {
          // No configured photo and no real product photo: a neutral device outline, never a photo of another model.
          media.classList.add('pf-hseries__media--empty');
          media.innerHTML = '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><rect x="14" y="4" width="20" height="40" rx="4"/><path d="M21 8h6"/></svg>';
        }
        const body = el('span', 'pf-hseries__body');
        body.append(el('span', 'pf-hseries__name', label), el('span', 'pf-hseries__sub', 'Bekijk de ' + label));
        const go = el('span', 'pf-hseries__go'); go.append(arrow());
        tile.append(media, body, go);
        root.insertBefore(tile, all);
      });
      done(root);
    });
  }

  // Devices: curated slots. A slot with a photo only shows a strictly saleable variant with exactly that model and
  // colour (optionally of a pinned product); a slot without a match is filled with another saleable device (best
  // selling, new model if possible) and its own product photo. Price, condition, stock and link: the real variant.
  function devices(root, data) {
    const count = Number(root.dataset.count) || 4;
    const configured = json(root.closest('.pf-hdevices') || document, '[data-pf-home-device-slots]');
    const slots = configured.length ? configured : Array.from({length: count}, () => ({}));
    data.load().then(([core, products]) => {
      const rows = core.hydrate(products, data.rules).rows, used = new Set(), models = new Set();
      const take = row => { used.add(String(row.id)); models.add(row.model); return row; };
      const picked = slots.map(slot => {
        if (slot.model && slot.color) {
          const row = rows.find(r => !used.has(String(r.id)) && (!slot.product || String(r.id) === String(slot.product)) && r.model === slot.model && r.color === slot.color);
          return row ? {row: take(row), photo: slot.src ? slot : null} : null;
        }
        if (slot.product) { const row = rows.find(r => !used.has(String(r.id)) && String(r.id) === String(slot.product) && r.image); return row ? {row: take(row)} : null; }
        return null;
      });
      picked.forEach((entry, index) => {
        if (entry) return;
        const row = rows.find(r => r.image && !used.has(String(r.id)) && !models.has(r.model)) || rows.find(r => r.image && !used.has(String(r.id)));
        picked[index] = row ? {row: take(row)} : null;
      });
      picked.filter(Boolean).forEach(({row, photo: slotPhoto}) => {
        const card = core.card(slotPhoto ? {...row, image: slotPhoto.src} : row);
        if (slotPhoto) {
          const img = card.querySelector('img'); photo(img, slotPhoto, 'pf-pcard__img--photo');
          card.dataset.pfPhotoModel = slotPhoto.model; card.dataset.pfPhotoColor = slotPhoto.color;
        }
        root.append(card);
      });
      done(root, picked.some(Boolean) ? '' : 'Er zijn op dit moment geen refurbished iPhones beschikbaar.');
      sizeTabs(root, rows, core, count);
    }).catch(() => done(root, 'De toestellen konden nu niet worden geladen. Bekijk alle iPhones via de link hierboven.'));
  }

  // Size tabs (ontwerppakket 00-home): Alle toestellen = the curated selection; Compact (≤ 5,8 inch) and Groot scherm
  // (≥ 6,5 inch) show strictly saleable devices of that screen size, one per model, with their own product photo.
  // Screen sizes are Apple's published diagonals (PrimeFoneSaved.screen). A tab without devices is not shown.
  function sizeTabs(root, rows, core, count) {
    const tabs = root.closest('.pf-hdevices') && root.closest('.pf-hdevices').querySelector('[data-pf-device-tabs]');
    const screen = window.PrimeFoneSaved && window.PrimeFoneSaved.screen;
    if (!tabs || !screen) return;
    const size = model => { const inch = screen[model]; return !inch ? '' : inch <= 5.8 ? 'compact' : inch >= 6.5 ? 'groot' : 'standaard'; };
    const pick = key => { const seen = new Set(); return rows.filter(r => r.image && size(r.model) === key && !seen.has(r.model) && seen.add(r.model)).slice(0, count); };
    const curated = [...root.children];
    const buttons = [...tabs.querySelectorAll('[data-size]')];
    buttons.forEach(btn => { if (btn.dataset.size && !pick(btn.dataset.size).length) btn.remove(); });
    const live = [...tabs.querySelectorAll('[data-size]')];
    if (live.length < 2) return;
    function select(btn) {
      live.forEach(b => { const on = b === btn; b.setAttribute('aria-selected', String(on)); b.tabIndex = on ? 0 : -1; });
      root.replaceChildren(...(btn.dataset.size ? pick(btn.dataset.size).map(row => core.card(row)) : curated));
    }
    live.forEach((btn, i) => {
      btn.addEventListener('click', () => select(btn));
      btn.addEventListener('keydown', e => { const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return; e.preventDefault(); const n = live[(i + d + live.length) % live.length]; n.focus(); select(n); });
    });
    tabs.hidden = false;
  }

  // Device finder: options from strictly saleable rows; every choice narrows the other lists (AND between, real
  // combinations only). Submits the collection filter parameters (pf_model, pf_storage, pf_condition, pf_max).
  function finder(form, data) {
    const selects = Object.fromEntries([...form.querySelectorAll('[data-pf-finder]')].map(sel => [sel.dataset.pfFinder, sel]));
    const count = form.querySelector('[data-pf-finder-count]');
    const label = {model: 'Alle modellen', storage: 'Alle opslag', condition: 'Alle condities'};
    data.load().then(([core, products]) => {
      const rows = core.hydrate(products, data.rules).rows;
      const choice = () => ({model: selects.model.value, storage: selects.storage.value, condition: selects.condition.value, max: selects.max.value});
      const fits = (row, c, skip) => (skip === 'model' || !c.model || row.model === c.model) && (skip === 'storage' || !c.storage || row.storage === c.storage) && (skip === 'condition' || !c.condition || row.condition === c.condition) && (!c.max || row.price <= Number(c.max) * 100);
      function refresh() {
        const c = choice();
        for (const key of ['model', 'storage', 'condition']) {
          const values = [...new Set(rows.filter(r => fits(r, c, key)).map(r => r[key]))];
          if (key === 'storage') values.sort((a, b) => parseInt(a) * (/TB/.test(a) ? 1024 : 1) - parseInt(b) * (/TB/.test(b) ? 1024 : 1));
          else if (key === 'condition') values.sort((a, b) => core.conditions.indexOf(a) - core.conditions.indexOf(b));
          else values.sort((a, b) => a.localeCompare(b, 'nl', {numeric: true}));
          const keep = selects[key].value;
          const any = el('option', '', label[key]); any.value = '';
          selects[key].replaceChildren(any, ...values.map(v => { const o = el('option', '', key === 'storage' ? v.replace(/(GB|TB)$/, ' $1') : v); o.value = v; return o; }));
          selects[key].value = values.includes(keep) ? keep : '';
        }
        const total = rows.filter(r => fits(r, choice())).length;
        count.textContent = total ? total + (total === 1 ? ' uitvoering past bij je keuze' : ' uitvoeringen passen bij je keuze') : 'Geen uitvoering past bij deze combinatie. Pas je keuze aan.';
        form.querySelector('[type="submit"]').disabled = !total;
      }
      form.addEventListener('change', refresh);
      refresh();
    }).catch(() => { count.textContent = ''; });
    // Clean URL: leave out empty choices.
    form.addEventListener('submit', () => { form.querySelectorAll('select').forEach(sel => { sel.disabled = !sel.value; }); setTimeout(() => form.querySelectorAll('select').forEach(sel => { sel.disabled = false; }), 0); });
  }
  function accFinder(form) {
    if (form.dataset.pfAccInit) return; form.dataset.pfAccInit = '1';
    const select = form.querySelector('[data-pf-acc-select]'), error = form.querySelector('[data-pf-acc-error]');
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!select.value) { error.hidden = false; select.focus(); return; }
      error.hidden = true; window.location.assign(select.value);
    });
    select.addEventListener('change', () => { if (select.value) error.hidden = true; });
  }

  function start() {
    document.querySelectorAll('[data-pf-acc-finder]').forEach(accFinder);
    const data = window.PrimeFoneRefurbData;
    const seriesRoot = document.querySelector('[data-pf-home-series]'), devicesRoot = document.querySelector('[data-pf-home-devices]');
    if (!data) { if (seriesRoot) done(seriesRoot); if (devicesRoot) done(devicesRoot, 'De toestellen konden nu niet worden geladen.'); return; }
    if (seriesRoot) series(seriesRoot, data);
    document.querySelectorAll('[data-pf-home-finder]').forEach(form => finder(form, data));
    if (devicesRoot) devices(devicesRoot, data);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
